@if (errorTransformationLogItem?.errorCode === 'UNPARSEABLE_BIGDECIMAL' || errorTransformationLogItem?.errorCode === 'UNPARSEABLE_INTEGER') {
  <span
    >
    In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> wird statt <i>{{errorTransformationLogItem.objects}}</i> ein Zahlwert erwartet.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'ANLAGENTYP_NOT_FOUND') {
  <span>
    In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> kann der Wert <i>{{errorTransformationLogItem.objects}}</i> keinem 'Anlagentyp Primärenergieträger' zugeordnet werden. Bitte verwenden Sie nur Werte aus der Auswahlliste.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'NETZZUORDNUNG_NOT_FOUND') {
  <span>
    Die Werte in den Spalten <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> können keiner validen Netzzuordnung im
    Leitsystem zugeordnet werden. Gültige Kombinationen können im TNB-Portal eingesehen werden, wenn Sie in der Detailansicht eines Erzeugers den Abschnitt 'Netzzuordnung' die jeweiligen Dropdown-Listen auswählen.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'ERZEUGUNGSANLAGE_NOT_UNIQUE_IN_EXCEL') {
  <span>
    Die Werte in den Spalten <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> kollidieren mit Erzeugungsanlagen aus folgenden Zeilen: {{ errorTransformationLogItem.objects.join(', ')}}.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'WESTNETZ_ID_DUPLICATE') {
    <span>
    Der Wert <i>{{ errorTransformationLogItem.columnNames[0] }}</i> kollidiert mit Erzeugungsanlagen aus folgenden Zeilen: {{ errorTransformationLogItem.objects.join(', ')}}.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'WESTNETZ_ID_NOTFOUND') {
  <span>
    In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> wurde eine ID (<i>{{errorTransformationLogItem.objects}}</i>) gefunden, die nicht existiert oder bereits gelöscht wurde.
    Wenn Sie diesen Datensatz neu anlegen wollen, löschen Sie bitte den Wert.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'UNDETERMINED_BOOLEAN') {
  <span>
    In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> sollte statt dem Wert <i>{{errorTransformationLogItem.objects[0]}}</i>  ausschließlich <i>Ja</i>
    oder <i>Nein</i> stehen. Bitte verwenden Sie nur Werte aus der Auswahlliste.
  </span>
}

@if (errorTransformationLogItem?.errorCode === 'BEANVALIDATION_VIOLATION') {
  <span>
    @if (errorTransformationLogItem?.constraint === 'Pattern') {
      <span>
        In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> entspricht der Wert <i>{{errorTransformationLogItem.objects}}</i> nicht dem erforderlichen Muster.
      </span>
    }
    @if (errorTransformationLogItem?.constraint === 'Size') {
      <span
        >
        In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> ist der Wert länger als der maximal zulässige.
      </span>
    }
    @if (errorTransformationLogItem?.constraint === 'DecimalMax' || errorTransformationLogItem?.constraint === 'Max') {
      <span
        >
        In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> liegt der Wert <i>{{errorTransformationLogItem.objects}}</i> über dem maximal zulässigen.
      </span>
    }
    @if (errorTransformationLogItem?.constraint === 'DecimalMin' || errorTransformationLogItem?.constraint === 'Min') {
      <span
        >
        In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> liegt der <i>{{errorTransformationLogItem.objects}}</i> unter der minimal zulässigen.
      </span>
    }
    @if (errorTransformationLogItem?.constraint === 'NotNull' || errorTransformationLogItem?.constraint === 'NotBlank' || errorTransformationLogItem?.constraint === 'NotEmpty') {
      <span
        >
        In der Spalte <i>{{formatArray(errorTransformationLogItem.columnNames)}}</i> wurde kein Wert ermittelt.
      </span>
    }
    @if (errorTransformationLogItem?.constraint === 'AbregelbareLeistungLowerThanInstallierteLeistungConstraint') {
      <span
        >
        Der abregelbare Anteil der Erzeugungsanlage darf nicht größer sein als die installierte Leistung.
      </span>
    }
  </span>
}


